import React, { useState } from 'react'
import PropTypes from 'prop-types'
import LessIcon from '../../../images/refer-a-friend/icon_faq_less.svg'
import MoreIcon from '../../../images/refer-a-friend/icon_faq_more.svg'

import {
  StyledContainer,
  StyledContent,
  StyledHeader,
  StyledBody,
} from './styles'

import { Box } from '../../atoms/box'
import { If } from '../../atoms/if'
import { Image } from '../../atoms/image'
import { Title } from '../../atoms/text'

export const Collapse = ({ children }) => {
  return (
    <StyledContainer>
      <If
        condition={!Array?.isArray(children)}
        render={() => (
          <StyledContent key={children.props.key}>{children}</StyledContent>
        )}
        renderElse={() =>
          children?.map((child) => (
            <StyledContent key={child.props.key}>{child}</StyledContent>
          ))
        }
      />
    </StyledContainer>
  )
}

export const Panel = ({ header, children, subHeader, expandable }) => {
  const [isActive, setIsActive] = useState(false)
  const toggleActive = () => {
    setIsActive((current) => !current)
  }
  return (
    <>
      <StyledHeader
        onClick={() => (expandable ? toggleActive() : null)}
        expandable={expandable}
      >
        <Title level={3} style={{ lineHeight: '1.2em' }}>
          {header}
        </Title>
        <If
          condition={expandable}
          render={() => (
            <Image url={isActive ? LessIcon : MoreIcon} width={24} />
          )}
        />
      </StyledHeader>
      <If
        condition={!!subHeader}
        render={() => <Box paddingTop="0.5em">{subHeader}</Box>}
      />
      <StyledBody className={isActive ? 'active' : ''}>{children}</StyledBody>
    </>
  )
}

Collapse.defaultProps = {
  children: [],
}

Collapse.propTypes = {
  children: PropTypes.any,
}

Panel.defaultProps = {
  header: '',
  children: [],
  subHeader: null,
  expandable: true,
}

Panel.propTypes = {
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.any,
  children: PropTypes.any.isRequired,
  expandable: PropTypes.bool,
}
